import { TRANSLATOR_SERVICE } from "src/utils/Api";
import sendBatchRequests from "src/utils/Api/sendBatchRequests";
import newRelicErrorReport from "src/utils/newRelic/newRelicErrorReport";

const cache = {};
let cacheAll = [];
export default async function fetchScopeOptions(type, mockData) {
  if (!cache[type]) {
    try {
      const res = await sendBatchRequests({
        filterField: "type",
        filterValue: type,
        requestParams: {
          service: TRANSLATOR_SERVICE,
          path: "/scopes",
          method: "GET",
          mockData,
        },
      });

      cacheAll.push(
        ...(res?.map(({ title, code, type: optionType }) => ({
          value: code,
          label: title,
          type: optionType,
        })) || [])
      );
    } catch (e) {
      console.error(e);
      newRelicErrorReport(
        e,
        "/Pages/Translation/utils/fetchScopeOptions.js - 26"
      );
      cache[type] = null;
      cacheAll = [];
    }
    cache[type] = cacheAll.filter((item) => item.type === type);
  }
  return cache[type] || [];
}

export function getAllOptions() {
  return cacheAll || [];
}

export const ScopeTypes = [
  { label: "Interfejs", value: 1 },
  { label: "Wartości proste", value: 2 },
  { label: "Opisy", value: 3 },
];
